class Storage {
  static isTelegramWebApp = !!Telegram.WebApp.initData;

  static stringifyValue<T>(value: T): string {
    return typeof value === 'string' ? value : JSON.stringify(value);
  }

  static async getItemFromTgCloud(key: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      Telegram.WebApp.CloudStorage.getItem(key, (error, value) => {
        if (error) {
          reject(error);
        }

        resolve(value);
      });
    });
  }

  static async setItemToTgCloud<T>(key: string, value: T): Promise<void> {
    return new Promise((resolve, reject) => {
      if (value) {
        const stringifyValue = this.stringifyValue(value);
        Telegram.WebApp.CloudStorage.setItem(
          key,
          stringifyValue,
          (error, _) => {
            if (error) {
              reject();
            }

            resolve();
          },
        );
      } else {
        reject();
      }
    });
  }

  static setItemToLocalStorage<T>(key: string, value: T): void {
    if (value) {
      const stringifyValue = this.stringifyValue(value);
      localStorage.setItem(key, stringifyValue);
    }
  }

  static getItemFromLocalStorage(key: string): string | null {
    return localStorage.getItem(key);
  }

  static async getItem(key: string): Promise<string | null> {
    try {
      return this.isTelegramWebApp
        ? await this.getItemFromTgCloud(key)
        : this.getItemFromLocalStorage(key);
    } catch (error) {
      console.error(error);

      return null;
    }
  }

  static async getParsedItem<T>(key: string): Promise<T | null> {
    const value = await this.getItem(key);

    return value ? JSON.parse(value) : null;
  }

  static async setItem<T>(key: string, value: T): Promise<void> {
    try {
      if (this.isTelegramWebApp) {
        await this.setItemToTgCloud(key, value);
      } else {
        this.setItemToLocalStorage(key, value);
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export { Storage };
